<div class="mt-5">
  <ng-container [ngSwitch]="hint.type">
    <div *ngSwitchCase="'help'">
      <div class="d-flex">
        <p500-ui-icon [name]="'other-question'" [size]="'16px'" [className]="'text-color--light-gray'" class="mt-2 mr-5"></p500-ui-icon>
        <span class="text-color--gray font-body-4">{{ hint.hint$ | async }}</span>
      </div>
    </div>
  </ng-container>
</div>
